import React from "react";
import { Nav } from "react-bootstrap";

const isActive = (path) => {
  let clsName = "";
  if (window.location.pathname.indexOf(path) > -1) {
    clsName += "active";
  }
  clsName += " p-0 mt-auto";

  return clsName;
};

const imageState = (nm) => {
  var src = process.env.PUBLIC_URL + "/images/" + nm;
  if (isActive(nm) === "") {
    src += "-d";
  }
  src += ".png";
  return <img src={src} height="19" alt={nm} />;
};

const Footer = () => {
  return (
    <div>
      <div className="footer ps-2">
        <img src={`${process.env.PUBLIC_URL}/images/facebook.png`} alt="Facebook" />
        <img className="mx-2" src={`${process.env.PUBLIC_URL}/images/twitter.png`} alt="Twitter" />
        <img src={`${process.env.PUBLIC_URL}/images/LinkedIn.png`} alt="LinkedIn" />
        <img className="mx-2" src={`${process.env.PUBLIC_URL}/images/Instagram.png`} alt="Instagram" />
        <img src={`${process.env.PUBLIC_URL}/images/YouTube.png`} alt="Youtube" />
      </div>

      <div className="mobileFooter">
        <Nav className="d-flex bg-white text-center justify-content-evenly shadow p-0  pb-4">
          <Nav.Link className={isActive("dashboard")} href={`${process.env.PUBLIC_URL}/dashboard`}>
            {imageState("dashboard")} <small className="d-block text-dark">Dashboard</small>
          </Nav.Link>
          <Nav.Link className={isActive("attendence")} href={`${process.env.PUBLIC_URL}/attendance`}>
            {imageState("attendence")} <small className="d-block text-dark">Attendance</small>
          </Nav.Link>
          <Nav.Link className={isActive("jobs")} href={`${process.env.PUBLIC_URL}/jobs`}>
            {imageState("jobs")} <small className="d-block text-dark">Jobs</small>
          </Nav.Link>
          <Nav.Link className={isActive("todo")} href={`${process.env.PUBLIC_URL}/todo`}>
            {imageState("todo")} <small className="d-block text-dark">Tasks</small>
          </Nav.Link>
        </Nav>
      </div>
    </div>
  );
};

export default Footer;
